import { useState, useCallback } from 'react';
import { SortConfig, SortDirection } from '@/shared/types/table';
import { toggleSortDirection } from '../utils/sorting';

export const useTableSort = (initialSort?: SortConfig) => {
  const [sortConfig, setSortConfig] = useState<SortConfig | undefined>(initialSort);

  const handleSort = useCallback((columnId: string) => {
    setSortConfig((prev) => {
      if (prev?.columnId === columnId) {
        const newDirection = toggleSortDirection(prev.direction);
        return newDirection ? { columnId, direction: newDirection } : undefined;
      }
      return { columnId, direction: 'asc' };
    });
  }, []);

  const clearSort = useCallback(() => {
    setSortConfig(undefined);
  }, []);

  const setSort = useCallback((columnId: string, direction: SortDirection) => {
    setSortConfig(direction ? { columnId, direction } : undefined);
  }, []);

  return {
    sortConfig,
    handleSort,
    clearSort,
    setSort,
  };
};
